module.exports = __webpack_public_path__ + "static/media/loader.87617b76.gif";